"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const sections = element.value.items
        .map((item) => {
        let title = item.label
            ? (0, rich_text_1.slateToMarkdown)(item.label, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim()
            : '';
        title = (0, md_utils_1.sanitizeInlineMd)(title);
        const head = title ? `### ${title}\n\n` : '';
        const body = context.renderNode ? context.renderNode(item.value) : '';
        const content = [head, body].filter(Boolean).join('');
        return content ? content + '\n\n' : '';
    })
        .filter(Boolean);
    if (sections.length === 0) {
        return '';
    }
    return sections.join('') + '\n';
};
exports.toMarkdown = toMarkdown;
